export default function (fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var immediate = arguments.length > 2 ? arguments[2] : undefined;
  var timeout;
  function debounced( /* ...args */
  ) {
    var _this = this;
    var args = arguments;
    var later = function later() {
      timeout = void 0;
      if (immediate !== true) {
        fn.apply(_this, args);
      }
    };
    clearTimeout(timeout);
    if (immediate === true && timeout === void 0) {
      fn.apply(this, args);
    }
    timeout = setTimeout(later, wait);
  }
  debounced.cancel = function () {
    clearTimeout(timeout);
  };
  return debounced;
}